import { Injectable } from '@angular/core';
import { BaseMapper } from '@shared/data';
import { ServicePublicSearchResultDto, SubcontractorPublicDto, SubcontractorsPublicSearchResultDto } from '../dto';
import { SubcontractorBookingModel, SubcontractorServiceModel, SubcontractorsBookingModel } from '../model';

@Injectable({
    providedIn: 'root',
})
export class SubcontractorsBookingMapper extends BaseMapper<SubcontractorsBookingModel, SubcontractorsPublicSearchResultDto> {
    public mapDtoToModel(dto: SubcontractorsPublicSearchResultDto, services?: ServicePublicSearchResultDto): SubcontractorsBookingModel {
        return {
            subcontractors: dto.subcontractors.map(subcontractor => this.mapSubcontractorDtoToModel(subcontractor, services?.services)),
        };
    }

    private mapSubcontractorDtoToModel(dto: SubcontractorPublicDto, services?: SubcontractorServiceModel[]): SubcontractorBookingModel {
        return {
            uuid: dto.uuid,
            name: dto.name,
            contractorUuid: dto.contractorUuid,
            services: dto.serviceUuids.map(serviceUuid => {
                const matchedService = services?.find(service => service.uuid === serviceUuid);
                return {
                    uuid: serviceUuid,
                    name: matchedService ? matchedService.name : undefined,
                };
            }),
        };
    }
}
